import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';
import { without as _without } from 'lodash';
import { sumBy as _sumBy } from 'lodash';

class MonthlyDistributionContainerController {  
  constructor(performanceManagementService, lookupService, $ngConfirm, $scope, $stateParams, growl, loadingService) {
    "ngInject";

    this.performanceManagementService = performanceManagementService;    
    this.lookupService = lookupService;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.growl = growl;
    this.loadingService = loadingService;

    this.years = [];
    this.brands = [];
    this.allBrandModels = [];
    this.vehicleConditionList = [];
    this.monthlyDistributions = [];

    this.selectedYear = null;
    this.emptyModel = {brandId: null, brandModelId: null, name: 'Please Select'};

    this.loadYears();
    this.loadMonthlyDistributions();
    this.loadBrands();
    this.loadBrandModels();
    this.loadVehicleConditions();
  }

  loadYears() {
    const startYear = 2014;
    const endYear = new Date().getFullYear();

    for(let i = endYear; i >= startYear - 1; i--) {
      this.years.push(i);
    }

    this.selectedYear = endYear;
  }

  loadMonthlyDistributions() {
    this.loadingService.showLoading('monthlyDistributionList', 'Loading Monthly Distributions ...');

    this.performanceManagementService.listMonthlyDistribution(this.$stateParams.locationId, this.selectedYear)
      .then(response => this.monthlyDistributions = response.data)
      .finally(() => {
        this.loadingService.hideLoading('monthlyDistributionList');
      });
  }

  loadBrands() {
    this.lookupService.lookupBrands()
      .then(brands => this.brands = brands);
  }

  loadBrandModels() {
    this.lookupService.lookupBrandModels()
      .then(brandModels => this.allBrandModels = brandModels);
  }

  loadVehicleConditions() {
    this.vehicleConditionList.push({id: 1, name: 'New'});
    this.vehicleConditionList.push({id: 2, name: 'Used'});
  }

  showAddDistribution() {
    this.$scope.errMsg = '';
    this.$scope.brands = this.brands;
    this.$scope.allBrandModels = this.allBrandModels;
    this.$scope.emptyModel = this.emptyModel;
    this.$scope.brandModels = [this.emptyModel];
    this.$scope.vehicleConditionList = this.vehicleConditionList;
    this.$scope.filterBrandModels = this.filterBrandModels;

    this.$scope.monthlyDistribution = {
      entityId: this.$stateParams.locationId,
      year: this.selectedYear, //Selected Year
      condition: 1, //New
      brandId: 1, //Default to All Brands New or Used
      brandModelId: null,
      targetType: 1, //For EnquiryCreated
      jan: 0, feb: 0, mar: 0,
      apr: 0, may: 0, jun: 0,
      jul: 0, aug: 0, sep: 0,
      oct: 0, nov: 0, dec: 0
    };

    this.$ngConfirm({
      title: 'Add New Distribution',
      contentUrl: `templates/performance/editMonthlyDistributionTemplate`,
      typeAnimation: false,
      columnClass: 'l',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: () => { 
              if (!this.validateAddDistribution()){
                return false;
              }
              
              this.addDistribution();
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }

  validateAddDistribution() {
    const mdToAdd = this.$scope.monthlyDistribution;

    if (this.getDistributionTotal(mdToAdd) <= 0) {
      this.$scope.errMsg = 'Please enter at least one value';

      return false;
    }

    const duplicate = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId);
    
    if (duplicate) {
      this.$scope.errMsg = 'This configuration is already added';

      return false;
    }

    const brandId = this.$scope.monthlyDistribution.brandId;
    const modelId = this.$scope.monthlyDistribution.brandModelId;

    /*
    * If there is a Brand Specified, without any Model
    * We need to get total of all distributions with makes
    * and the combined total should be less than All 
    */
    if (brandId && !modelId) {
      //Get All Distribution First
      const all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);    

      //If All Category Exist, then we can find other brands under All
      if (all) {
        const brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];    
        brandDistributions.push(mdToAdd);
        const brandDistributionsCombined = this.combineDistributions(brandDistributions);
        const month = this.isBelowLimit(brandDistributionsCombined, all);

        if (month) {
          this.$scope.errMsg = `Combined total of all brand(s) for the month of ${month}, exceeds the All Category`; 
          return false; 
        }
      }
    }

    /*
    * If the Brand and BrandModel both specified
    * 1- If the Brand exists, we need to get the total of all distributions
    * under the Brand, and the combined total should be less than Brand
    * 2- If the Brand does not exist, we need to check the combined total
    * of this brandmodel along with any others brands under all category
    */
    if (brandId && modelId) {
      //Get Brand Distribution First
      const brand = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null);          

      if (brand) {
        const brandModelDistributions = this.findBrandModelDistributions(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId) || [];
        brandModelDistributions.push(mdToAdd);
        const brandModelDistributionsCombined = this.combineDistributions(brandModelDistributions);
        const month = this.isBelowLimit(brandModelDistributionsCombined, brand);

        if (month) {
          this.$scope.errMsg = `Combined total of all brand models(s) for the month of ${month}, exceeds the All Category`; 
          return false; 
        }        
      }
      else {
        const all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);    

        if (all) {
          const brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];    
          brandDistributions.push(mdToAdd);
          const brandDistributionsCombined = this.combineDistributions(brandDistributions);
          const month = this.isBelowLimit(brandDistributionsCombined, all);
  
          if (month) {
            this.$scope.errMsg = `Combined total of all brand(s) for the month of ${month}, exceeds the All Category`; 
            return false; 
          }          
        }
      }
    }

    return true;
  }

  addDistribution() {
    this.loadingService.showLoading('monthlyDistributionList', 'Adding Monthly Distribution ...');

    this.performanceManagementService.addMonthlyDistribution(this.$scope.monthlyDistribution)
      .then(response => {
        this.$scope.monthlyDistribution.monthlyDistributionId = response.data;
        this.$scope.monthlyDistribution.conditionText = _find(this.vehicleConditionList, o => o.id === this.$scope.monthlyDistribution.condition).name;
        this.$scope.monthlyDistribution.brandName = _find(this.brands, o => o.brandId === this.$scope.monthlyDistribution.brandId).name;
        const brandModel = _find(this.allBrandModels, o => o.brandModelId === this.$scope.monthlyDistribution.brandModelId)
        this.$scope.monthlyDistribution.brandModelName = brandModel != null ? brandModel.name : '';
        this.$scope.monthlyDistribution.targetTypeText = this.$scope.monthlyDistribution.targetType === 1 ? 'EnquiryCreated' : 'EnquiryDelivered';
        this.$scope.monthlyDistribution.total = this.getDistributionTotal(this.$scope.monthlyDistribution);

        this.monthlyDistributions.push(this.$scope.monthlyDistribution);

        this.growl.success('Distribution added successfully', {ttl: 5000});
      })
      .finally(() => {
        this.loadingService.hideLoading('monthlyDistributionList');
      });
  }

  showEditDistribution(md) {
    this.$scope.errMsg = '';
    this.$scope.brands = this.brands;    
    this.$scope.brandModels = _filter(this.allBrandModels, o => o.brandId === md.brandId);
    this.$scope.vehicleConditionList = this.vehicleConditionList;
    
    this.$scope.monthlyDistribution = Object.assign({}, md);;

    this.$ngConfirm({
      title: 'Edit New Distribution',
      contentUrl: `templates/performance/editMonthlyDistributionTemplate`,
      typeAnimation: false,
      columnClass: 'l',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: () => {               
              if (!this.validateEditDistribution()){
                return false;
              }
              
              this.editDistribution();
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }

  validateEditDistribution() {
    const mdToAdd = this.$scope.monthlyDistribution;

    if (this.getDistributionTotal(mdToAdd) <= 0) {
      this.$scope.errMsg = 'Please enter at least one value';

      return false;
    }
    
    const brandId = this.$scope.monthlyDistribution.brandId;
    const modelId = this.$scope.monthlyDistribution.brandModelId;

    /*
    * If there is a Brand Specified, without any Model
    * We need to get total of all distributions with makes
    * and the combined total should be less than All 
    */
    if (brandId && brandId !== 1 && !modelId) {
      //Get All Distribution First
      const all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);    

      //If All Category Exist, then we can find other brands under All
      if (all) {
        let brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];    
        //Exclude it self from Total
        brandDistributions = _without(brandDistributions, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null));
        brandDistributions.push(mdToAdd);
        const brandDistributionsCombined = this.combineDistributions(brandDistributions);
        const month = this.isBelowLimit(brandDistributionsCombined, all);

        if (month) {
          this.$scope.errMsg = `Combined total of all brand(s) for the month of ${month}, exceeds the All Category`; 
          return false; 
        }
      }
    }

    /*
    * If the Brand and BrandModel both specified
    * 1- If the Brand exists, we need to get the total of all distributions
    * under the Brand, and the combined total should be less than Brand
    * 2- If the Brand does not exist, we need to check the combined total
    * of this brandmodel along with any others brands under all category
    */
    if (brandId && modelId) {
      //Get Brand Distribution First
      const brand = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null);          
      
      if (brand) {
        let brandModelDistributions = this.findBrandModelDistributions(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId) || [];
        //Exclude it self from Total
        brandModelDistributions = _without(brandModelDistributions, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId));
        brandModelDistributions.push(mdToAdd);
        const brandModelDistributionsCombined = this.combineDistributions(brandModelDistributions);
        const month = this.isBelowLimit(brandModelDistributionsCombined, brand);

        if (month) {
          this.$scope.errMsg = `Combined total of all brand models(s) for the month of ${month}, exceeds the All Category`; 
          return false; 
        }        
      }
      else {
        const all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);    

        if (all) {
          let brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];    
          //Exclude it self from Total
          brandDistributions = _without(brandDistributions, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId));          
          brandDistributions.push(mdToAdd);
          const brandDistributionsCombined = this.combineDistributions(brandDistributions);
          const month = this.isBelowLimit(brandDistributionsCombined, all);
  
          if (month) {
            this.$scope.errMsg = `Combined total of all brand(s) for the month of ${month}, exceeds the All Category`; 
            return false; 
          }          
        }
      }
    }    

    return true;
  }  

  editDistribution() {
    this.loadingService.showLoading('monthlyDistributionList', 'Updating Monthly Distribution ...');

    this.performanceManagementService.editMonthlyDistribution(this.$scope.monthlyDistribution)
      .then(response => {
        const md = _find(this.monthlyDistributions, o => o.monthlyDistributionId === this.$scope.monthlyDistribution.monthlyDistributionId);
        md.jan = this.$scope.monthlyDistribution.jan;
        md.feb = this.$scope.monthlyDistribution.feb;
        md.mar = this.$scope.monthlyDistribution.mar;
        md.apr = this.$scope.monthlyDistribution.apr;
        md.may = this.$scope.monthlyDistribution.may;
        md.jun = this.$scope.monthlyDistribution.jun;
        md.jul = this.$scope.monthlyDistribution.jul;
        md.aug = this.$scope.monthlyDistribution.aug;
        md.sep = this.$scope.monthlyDistribution.sep;
        md.oct = this.$scope.monthlyDistribution.oct;
        md.nov = this.$scope.monthlyDistribution.nov;
        md.dec = this.$scope.monthlyDistribution.dec;

        this.growl.success('Distribution Updated successfully', {ttl: 5000});
      })
      .finally(() => {
        this.loadingService.hideLoading('monthlyDistributionList');
      });
  }

  showRemoveDistribution(monthlyDistributionId){
    this.$ngConfirm({
      title: 'Remove Distribution',
      content: `Are you sure you want to delete this Distribution ?`,
      typeAnimation: false,
      type: 'red',
      buttons: {
        yes: {
            text: 'Delete',
            btnClass: 'btn-danger',
            action: () => { 
              this.removeDistribution(monthlyDistributionId);
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }

  removeDistribution(monthlyDistributionId) {
    this.loadingService.showLoading('monthlyDistributionList', 'Removing Monthly Distribution ...');

    this.performanceManagementService.removeMonthlyDistribution(this.$stateParams.locationId, monthlyDistributionId)
      .then(response => {
        const md = _find(this.monthlyDistributions, o => o.monthlyDistributionId === monthlyDistributionId);
        
        this.monthlyDistributions = _without(this.monthlyDistributions, md);

        this.growl.success('Distribution Deleted successfully', {ttl: 5000});
      })
      .finally(() => {
        this.loadingService.hideLoading('monthlyDistributionList');
      });
  }

  isPositive(number) {
    return number >= 0;
  }

  filterBrandModels(md) {
    this.brandModels = [this.emptyModel];
    this.brandModels.push(..._filter(this.allBrandModels, o => o.brandId === md.brandId));
    
    md.brandModelId = null;
  }

  getDistributionTotal(md){
    return md.jan + md.feb + md.mar + md.apr 
      + md.may + md.jun + md.jul + md.aug 
      + md.sep + md.oct + md.nov + md.dec;
  }

  isBelowLimit(mdToUpdate, mdToCompare) {
    if (mdToUpdate.jan > mdToCompare.jan) {
      return "Jan";
    }

    if (mdToUpdate.feb > mdToCompare.feb) {
      return "Feb";
    }    

    if (mdToUpdate.mar > mdToCompare.mar) {
      return "Mar";
    }    

    if (mdToUpdate.apr > mdToCompare.apr) {
      return "Apr";
    }

    if (mdToUpdate.may > mdToCompare.may) {
      return "May";
    }

    if (mdToUpdate.jun > mdToCompare.jun) {
      return "Jun";
    }

    if (mdToUpdate.jul > mdToCompare.jul) {
      return "Jul";
    }

    if (mdToUpdate.aug > mdToCompare.aug) {
      return "Aug";
    }

    if (mdToUpdate.sep > mdToCompare.sep) {
      return "Sep";
    }

    if (mdToUpdate.oct > mdToCompare.oct) {
      return "Oct";
    }

    if (mdToUpdate.nov > mdToCompare.nov) {
      return "Nov";
    }

    if (mdToUpdate.dec > mdToCompare.dec) {
      return "Dec";
    }

    return null;
  }

  combineDistributions(distributions) {
    let distribution = {};

    distribution.jan = _sumBy(distributions, o => o.jan);
    distribution.feb = _sumBy(distributions, o => o.feb);
    distribution.mar = _sumBy(distributions, o => o.mar);
    distribution.apr = _sumBy(distributions, o => o.apr);
    distribution.may = _sumBy(distributions, o => o.may);
    distribution.jun = _sumBy(distributions, o => o.jun);
    distribution.jul = _sumBy(distributions, o => o.jul);
    distribution.aug = _sumBy(distributions, o => o.aug);
    distribution.sep = _sumBy(distributions, o => o.sep);
    distribution.oct = _sumBy(distributions, o => o.oct);
    distribution.nov = _sumBy(distributions, o => o.nov);
    distribution.dec = _sumBy(distributions, o => o.dec);

    return distribution;
  }

  findDistribution(condition, targetType, brandId, brandModelId) {
    return _find(this.monthlyDistributions, o => 
      o.condition === condition && o.targetType === targetType
      && o.brandId === brandId && o.brandModelId === brandModelId);
  }

  findBrandDistributions(condition, targetType) {
    return _filter(this.monthlyDistributions, o => 
      o.condition === condition && o.targetType === targetType
      && o.brandId !== 1 && o.brandModelId === null);
  }

  findBrandModelDistributions(condition, targetType, brandId) {
    return _filter(this.monthlyDistributions, o => 
      o.condition === condition && o.targetType === targetType && o.brandId === brandId && o.brandModelId !== null);
  }  
}

export default MonthlyDistributionContainerController;



// WEBPACK FOOTER //
// ./client/app/components/admin/monthlyDistributionManagement/monthlyDistributionContainer/monthlyDistributionContainer.controller.js